export default function PaymentErrorPage() {
  return (
    <div className="text-center p-8">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Payment Failed</h1>
      <p>There was a problem with your payment. Please try again or contact support.</p>
      <a href="/owner/invoices" className="mt-4 inline-block text-blue-700 underline">Go to My Invoices</a>
    </div>
  );
}
